import lang from "@/views/modules/RelatedLinks/language/en";
//import Editor from '@tinymce/tinymce-vue';
export default {
    name: "edit-relatedLink",
    components: {
//        'editor': Editor,
    },
    data() {
        return {
            loading: true,
            relatedLink: {},
            lang:[],
        }
    },
    mounted() {
        this.getRelatedLink();
        this.lang = lang;
    },
    methods: {
        saveRelatedLink() {
            const self = this;
            self.loading = true;
            axios.put('api/modules/relatedLinks/' + self.$route.params.id, self.relatedLink).then(function () {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data updated correctly').toString(),
                    type: 'success'
                });
            }).catch(function () {
                self.loading = false;
            });
        },
        getRelatedLink() {
            const self = this;
            self.loading = true;
             window.currentAction = 'list';
                axios.get('api/modules/relatedLinks/' + self.$route.params.id).then(function (response) {
                self.relatedLink = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        
    }
}